module.exports = __webpack_public_path__ + "static/media/category_icon.d9b0343d.png";